export default function createId(values) {
    const min = Math.ceil(0);
    const max = Math.floor(1000);
    const random = Math.floor(Math.random() * (max - min + 1)) + min;
    if (values.includes(random)) {
        createId(values);
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
